//
import ProviderModel from '@/models/Purchase/PchProvider'
import UserModel from '@/models/General/GUser'

//
import DetailPurchaseOrderUpdateHeaders from './headers'

//
import { required } from '@/services/validations'

//
export default props => [
    {
        name: 'pch_provider_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemKey: 'id',
            itemText: 'alias_name',
            itemValue: 'id',
            label: 'Proveedor',
            model: ProviderModel,
            noDataText: 'Sin proveedores.',
            noObject: true,
            rules: [required],
        },
    },
    {
        name: 'pch_provider_branch_offices_address',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Sucursal',
            rules: [required],
            readonly: true,
        },
    },
    {
        name: 'g_originator_user_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Responsable',
            model: UserModel,
            noDataText: 'Sin usuarios.',
            noObject: true,
            rules: [required],
        },
    },
    {
        name: 'pch_purchase_order_state_name',
        type: 'text-field',
        flex: {
            sm3: true,
            xs12: true,
        },
        props: {
            label: 'Estado',
            readonly: true,
        },
    },
    {
        name: 'invoice_numbers',
        type: 'combobox',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Facturas',
            rules: [required],
        },
    },
    {
        name: 'wh_warehouse_name',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Bodega',
            rules: [required],
        },
    },
    {
        name: 'created_at',
        type: 'date-field',
        flex: {
            sm3: true,
            xs12: true,
        },
        props: {
            label: 'Creado',
            readonly: true,
        },
    },
    {
        name: 'receiving_date',
        type: 'date-field',
        flex: {
            sm3: true,
            xs12: true,
        },
        props: {
            label: 'Recepcion',
            readonly: true,
        },
    },
    {
        name: 'pch_detail_purchase_orders',
        type: 'table-field',
        flex: {
            'pt-0': true,
            'd-grid': true,
            'xs12': true,
        },
        props: {
            class: 'v-card elevation-2 mb-4',
            headers: DetailPurchaseOrderUpdateHeaders(props),
            noDataText: 'Sin productos.',
            toolbarTitle: 'Lista de productos incluidos en la orden',
            rules: [required],
        },
    },
    {
        name: 'observation',
        type: 'textarea',
        flex: {
            xs12: true,
            sm6: true,
        },
        props: {
            label: 'Observación',
        },
    },
    {
        name: 'reception_comment',
        type: 'textarea',
        flex: {
            xs12: true,
            sm6: true,
        },
        props: {
            label: 'Comentario de recepcion',
        },
    },
]
